import _ from 'lodash';

import { ordenarAlfabeticament, ordenacioDates } from '../../commons/ordenacio';
import { MASCARA_YYYYMMDD } from '../../commons/gestioDates';

const configuracioTaula = [
    {
        title: 'Tipus',
        dataIndex: 'tipus',
        key: 'tipus',
        className: 'estacio-incidencies-columna-tipus',
        sorter: (itemA, itemB) => ordenarAlfabeticament(itemA.tipus, itemB.tipus)
    },
    {
        title: 'Descripció',
        dataIndex: 'descripcio',
        className: 'salt-de-linia',
        key: 'descripcio'
    },
    {
        title: 'Data inici',
        dataIndex: 'dataInici',
        key: 'dataInici',
        className:'estacio-introduccio-taula-columna-data',
        sorter: (itemA, itemB) => ordenacioDates(itemA.dataInici, itemB.dataInici, MASCARA_YYYYMMDD),
        defaultSortOrder: 'descend'
    },
    {
        title: 'Data fi',
        dataIndex: 'dataFi',
        key: 'dataFi',
        className:'estacio-introduccio-taula-columna-data',
        sorter: (itemA, itemB) => ordenacioDates(itemA.dataFi, itemB.dataFi, MASCARA_YYYYMMDD),
    }
];

export const columnesTaulaIncidencies = () => (_.cloneDeep(configuracioTaula));


// WEBPACK FOOTER //
// ./src/components/estacio/configuracioTaulaIncidencies.js